import {makeMap} from './makeMap'
import {makeMapMarkers} from './makeMapMarkers'
import {createInfoWindowContent} from './createInfoWindowContent'

export const googleMapApi = {
  makeMap,
  makeMapMarkers,
  createInfoWindowContent,
}